import WsConstants from 'scoreboard/admin/model/ws-constants'
const { WS_VENDOR_TYPE } = WsConstants
import i18n from 'scoreboard/components/i18n'

function getWebServiceTypeTitle(vendorType, defaultTitle) {
	if (vendorType === WS_VENDOR_TYPE.ORACLE_NETSUITE) {
		return i18n.get('admin.importConnections.web-service.rest.vendor.oracleNetSuite')
	}

	return defaultTitle
}

export { getWebServiceTypeTitle }